import { render } from "./MemberItem.vue?vue&type=template&id=68117f36&scoped=true"
import script from "./MemberItem.vue?vue&type=script&lang=js"
export * from "./MemberItem.vue?vue&type=script&lang=js"

import "./MemberItem.vue?vue&type=style&index=0&id=68117f36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68117f36"

export default script